/* ------------------------------------------------------------------
   METTE DITMER - egne scripts til Prestige 11 (22-10, Claude)
   1) Kollektioner: "Vis flere" + automatisk indlaesning i bunden
   Fejler noget, goer scriptet ingenting, og siden virker som foer.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  /* 1) Vis flere / automatisk indlaesning --------------------------------- */
  function countText(root, shown) {
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var showing = root.getAttribute('data-word-showing');
    var noun = root.getAttribute('data-word-products');
    if (shown >= total) {
      return showing + ' ' + root.getAttribute('data-word-all') + ' ' + total + ' ' + noun;
    }
    return showing + ' ' + shown + ' ' + root.getAttribute('data-word-of') + ' ' + total + ' ' + noun;
  }

  function loadMore(button) {
    if (!button || button.classList.contains('is-loading')) { return; }
    var root = button.closest('[data-md-load-more-root]');
    var main = button.closest('.collection__main') || document;
    var list = main.querySelector('product-list, .product-list');
    var url = button.getAttribute('href');
    if (!root || !list || !url) { return; }

    button.classList.add('is-loading');
    button.textContent = root.getAttribute('data-label-loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) { throw new Error('HTTP ' + response.status); }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextList = doc.querySelector('product-list, .product-list');
        var added = 0;

        /* Uventet svar: gaa bare til naeste side som et almindeligt link */
        if (!nextList) { throw new Error('no product list'); }

        if (nextList) {
          while (nextList.firstElementChild) {
            var node = document.adoptNode(nextList.firstElementChild);
            if (node.tagName === 'PRODUCT-CARD') { added++; }
            list.appendChild(node);
          }
        }

        var total = parseInt(root.getAttribute('data-total'), 10) || 0;
        var shown = (parseInt(root.getAttribute('data-shown'), 10) || 0) + added;
        if (shown > total) { shown = total; }
        root.setAttribute('data-shown', shown);

        var counter = root.querySelector('[data-md-load-more-count]');
        if (counter) { counter.textContent = countText(root, shown); }

        var nextButton = doc.querySelector('[data-md-load-more]');
        if (nextButton && added > 0) {
          button.setAttribute('href', nextButton.getAttribute('href'));
          button.textContent = root.getAttribute('data-label-more');
          button.classList.remove('is-loading');
        } else if (button.parentNode) {
          button.parentNode.removeChild(button);
        }
        queueAutoLoad();
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-md-load-more]') : null;
    if (!button) { return; }
    event.preventDefault();
    loadMore(button);
  });

  var queued = false;

  function autoLoadCheck() {
    queued = false;
    var button = document.querySelector('[data-md-load-more]:not(.is-loading)');
    if (!button || !button.offsetParent) { return; }
    if (button.getBoundingClientRect().top < window.innerHeight + 600) {
      loadMore(button);
    }
  }

  function queueAutoLoad() {
    if (queued) { return; }
    queued = true;
    window.requestAnimationFrame(autoLoadCheck);
  }

  window.addEventListener('scroll', queueAutoLoad, { passive: true });
  window.addEventListener('resize', queueAutoLoad);
  if (document.readyState === 'complete') {
    queueAutoLoad();
  } else {
    window.addEventListener('load', queueAutoLoad);
  }

  /* Sprog (bruges af produkttekst) */
  var isDanish = (document.documentElement.lang || 'da').toLowerCase().indexOf('da') === 0;

  /* 2) Produkttekst: intro + fakta --------------------------------------------- */
  function enhanceDescription() {
    var rte = document.querySelector('.md-product-description');
    if (!rte || rte.getAttribute('data-md-enhanced')) { return; }

    /* Roer ikke tekster med links, billeder, tabeller eller lister */
    if (rte.querySelector('a, img, table, iframe, video, ul, ol')) { return; }

    var text = (rte.innerText || '').replace(/\r/g, '').replace(/ /g, ' ');
    var start = text.search(/(^|\n)\s*Størrelse\s*:/i);
    if (start <= 0) { return; }

    var story = text.slice(0, start).trim();
    var lines = text.slice(start).split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean);

    /* Alle fakta-linjer skal ligne "Overskrift: vaerdi" */
    var facts = [];
    for (var i = 0; i < lines.length; i++) {
      var match = lines[i].match(/^([^:]{2,30}):\s*(.+)$/);
      if (!match) { return; }
      facts.push({ label: match[1].trim(), value: match[2].trim() });
    }
    if (!facts.length || story.length < 40) { return; }

    var wrapper = document.createElement('div');

    var storyEl = document.createElement('div');
    storyEl.className = 'MdStory';
    story.split(/\n+/).forEach(function (paragraph) {
      paragraph = paragraph.trim();
      if (!paragraph) { return; }
      var p = document.createElement('p');
      p.textContent = paragraph;
      storyEl.appendChild(p);
    });
    wrapper.appendChild(storyEl);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'MdStory__Toggle';
    toggle.textContent = isDanish ? 'Læs mere' : 'Read more';
    toggle.setAttribute('aria-expanded', 'false');
    wrapper.appendChild(toggle);

    var list = document.createElement('ul');
    list.className = 'MdFacts';
    facts.forEach(function (fact) {
      var li = document.createElement('li');
      var label = document.createElement('strong');
      label.textContent = fact.label + ':';
      li.appendChild(label);
      li.appendChild(document.createTextNode(' ' + fact.value));
      list.appendChild(li);
    });
    wrapper.appendChild(list);

    rte.innerHTML = '';
    rte.appendChild(wrapper);
    rte.setAttribute('data-md-enhanced', '1');

    /* Klap kun teksten sammen, hvis den er lang */
    storyEl.classList.add('is-collapsed');
    if (storyEl.scrollHeight <= storyEl.clientHeight + 4) {
      storyEl.classList.remove('is-collapsed');
      toggle.hidden = true;
    }

    toggle.addEventListener('click', function () {
      var collapsed = storyEl.classList.toggle('is-collapsed');
      toggle.textContent = collapsed ? (isDanish ? 'Læs mere' : 'Read more') : (isDanish ? 'Vis mindre' : 'Show less');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDescription);
  } else {
    enhanceDescription();
  }


  /* 3) Tillidslinje: "Paa lager"-linjen foelger den valgte variant ------------- */
  function mdUpdateStock(variant) {
    var items = document.querySelectorAll('[data-md-stock]');
    var inStock = !!(variant && variant.available && (typeof variant.inventory_quantity !== 'number' || !variant.inventory_management || variant.inventory_quantity > 0));
    for (var i = 0; i < items.length; i++) { items[i].hidden = !inStock; }
  }
  ['variant:change', 'variant:changed'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant !== undefined) { mdUpdateStock(variant); }
    });
  });

  /* 4) "Laeg i kurv" i look-kortene (AW26 og Shop the look): tilfoej uden at
        forlade siden og aabn kurven. Fejler noget, sendes formularen normalt. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('AW26Look__CardForm')) { return; }
    if (!window.fetch || !window.FormData) { return; }
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) { button.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) { throw new Error('HTTP ' + response.status); }
      return response.json();
    }).then(function () {
      if (button) { button.disabled = false; }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        setTimeout(function () { drawer.show(); }, 400);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () {
      if (button) { button.disabled = false; }
      form.submit();
    });
  });
})();
